export default {
    'Close menu': 'بستن منو',
    'Close submenu': 'بستن زیرمنو',
    'Open submenu': 'بازکردن زیرمنو',
    'Toggle submenu': 'سوییچ زیرمنو'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/screenreader/translations/fa.js
// module id = 103
// module chunks = 0